/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Biblio API Adapter
 * API contract for the Biblio API adapter service.
 *
 * ## Adapter principles
 *
 * This adapter exposes two controlled subsets of the `Biblio API`: a browser-safe subset for end-user clients and a restricted subset for authorized server-to-server clients. Some endpoints are available in both subsets.
 *
 * - **Bearer-only client auth**: clients send one opaque `bearerAuth` token to the adapter.
 *   `Biblio API` credentials (`x-api-key` and `Biblio API` bearer token) are handled internally in the adapter.
 * - **User context derivation**: client-supplied `user_id` is not accepted on user-scoped
 *   operations. See **Authentication and user identity** below.
 * - **Automatic user provisioning**: the adapter ensures that authenticated users exist
 *   in `Biblio API` by internally calling `POST /v1/auth/create-sign-in-token` with
 *   `create_if_not_exists: true`. The created user is associated with the resolved
 *   `user_id` and `organization_third_party_id` (see **Authentication and user identity**).
 * - **Response transparency**: responses include `x-response-source` (`adapter` or `wedobooks`)
 *   and `x-request-id` for correlation and debugging.
 *
 * ## Authentication and user identity
 *
 * **Token**
 *
 * Obtain an OAuth2 access token from [login.bib.dk](https://login.bib.dk) and send it as `Authorization: Bearer <token>`.
 *
 * **Endpoint access**
 *
 * Endpoints that read or change a user's loans, reservations, or user data require a token representing the end user, issued via the OAuth2 `authorization_code` grant.
 *
 * Metadata and sample endpoints can be accessed with either an end-user token or a server-to-server token.
 *
 * `GET /v1/organizations` accepts any valid bearer token. If the token resolves to an end user, the client may omit `third_party_id`; the adapter then uses the user's municipality. Otherwise, the client must send `organization_id` or `third_party_id`.
 *
 * Server-to-server access requires a token issued via the OAuth2 `client_credentials` grant. The OAuth client must be configured with access to the endpoint.
 *
 * **Identity resolution**
 *
 * User-scoped endpoints do not accept client-supplied `user_id` or organization ids. Resolve them from login.bib.dk userinfo `attributes` as follows:
 *
 * 1. If both `uniqueId` and `municipality` are present:
 *    - `user_id` = `uniqueId`
 *    - `organization_third_party_id` = `municipality`
 *    - `user_data.type` = `"library"`
 * 2. Otherwise, use the Unilogin fallback:
 *    - `user_id` = `uniloginUniIdHash`
 *    - `organization_third_party_id` = `uniloginMunicipality`
 *    - `user_data.type` = `"unilogin"`
 *    - `user_data.institution_id` = the first id in `uniloginInstitutionIds`
 *
 *
 * Unilogin fallback requires at least one institution id and an active Unilogin license. Without an active license, the adapter returns 403 with `User is missing license`.
 *
 * If identity cannot be resolved, the adapter returns 403 Forbidden.
 * ## Unsupported endpoints in adapter
 *
 * These endpoints are available in the `Biblio API`, but not in this adapter.
 *
 * - `POST /v1/auth/sign-in` (used internally)
 * - `POST /v1/auth/create-user`
 * - `Webhooks` (Biblio API outbound webhook events)
 * - `GET /v1/inventory`
 * - `GET /v1/shelves`
 * - `GET /v1/onix/{material_id}`
 * - `GET /v1/onix/pull/alpha`
 * - `GET /v1/onix/pull/delta/{from_utc_timestamp}`
 *
 * OpenAPI spec version: 1.0.0
 */

export type SampleFormat = (typeof SampleFormat)[keyof typeof SampleFormat]

export const SampleFormat = {
  epub: "epub",
  mp3: "mp3",
} as const
